import { render } from "./TopSearch.vue?vue&type=template&id=416e2fd7&ts=true"
import script from "./TopSearch.vue?vue&type=script&lang=ts"
export * from "./TopSearch.vue?vue&type=script&lang=ts"

import "./TopSearch.vue?vue&type=style&index=0&id=416e2fd7&lang=scss"

import exportComponent from "/Users/nicolacentonze/Desktop/Projects/cons-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__